import {enConfig} from './en';

export const frConfig = {
    ...enConfig.base,
    bismi:'Au nom de Dieu, le Tout Miséricordieux, le Très Miséricordieux.',
    salaam:'Salaam',
    header:{
        signup : "Inscription pour une meilleure santé",
        signin : "Connection",    
        signout : "Sortie",
        close: "Fermer",
        profile: "Profil",
    },
    
    home:{
        title : 'Numérisation',
        article : 'Articles',
        contact : 'Contact',
        about: 'A propos',
        connected: 'Vous devez être inscrit'
    },

    blog: {
        ...enConfig.blog,
        title :'Articles les plus intéressants',
    },

    about:{
        title:'Plus sain',
        content:'Utiliser la technologie et l\'IA pour rendre les gens plus sains',
    },

    contact:{
        title:'Contactez-nous',
        message:'Veuillez remplir le formulaire ci-dessous pour nous envoyer un e-mail',
        confirm:'Confirmation de contact',
        content:'Veuillez remplir le code que nous vous avons envoyé par e-mail pour le confirmer',
        recipient:"Veuillez confirmer les informations du destinataire.",
        feedback : 'Nous avons reçu votre message, nous vous contacterons dès que possible',
        warning : "Vous devez confirmer votre e-mail avant de continuer"
    },
    
    getApp : {
        name : 'Télécharger Services App',
        info : 'Télécharger Services App',
        label : 'Télécharger Services App',
    },

}
